export const EXTERNAL_BOOKINGS_ENABLED = false;
